import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import {
  AppointmentBranch,
  AppointmentData,
  AppointmentSetting as AppointmentSettings,
  ICreateAppointment,
  RecentAppointment,
} from '@/type/Appointment'

export const useAppointmentStore = defineStore('appointment', () => {
  const appointment = ref<AppointmentData>()
  const branches = ref<AppointmentBranch[]>([])
  const settings = ref<AppointmentSettings>()
  const bookingData = ref<ICreateAppointment>()
  const otToken = ref<string | null>(null)
  const noAppointmentsCache = ref<Record<string, any[]>>({})

  function cacheAppointmentData(appointmentData: AppointmentData) {
    const deepCopy = JSON.parse(JSON.stringify(appointmentData))
    appointment.value = deepCopy
  }
  function cacheAppointmentBranches(branchesData: AppointmentBranch[]) {
    const deepCopy = JSON.parse(JSON.stringify(branchesData))
    branches.value = deepCopy
  }
  function cacheAppointmentSettings(settingData: AppointmentSettings) {
    const deepCopy = JSON.parse(JSON.stringify(settingData))
    settings.value = deepCopy
  }
  function cacheBookingData(_createData: ICreateAppointment) {
    const deepCopy = JSON.parse(JSON.stringify(_createData))
    bookingData.value = deepCopy
  }

  function cacheOtToken(_otToken: string | null) {
    otToken.value = _otToken
  }

  function cacheNoAppointments(branchUuid: string, data: any[]) {
    noAppointmentsCache.value = { ...noAppointmentsCache.value, [branchUuid]: data }
  }

  return {
    // getters
    appointmentData: computed(() => appointment.value),
    branches: computed(() => branches.value),
    settings: computed(() => settings.value),
    bookingData: computed(() => bookingData.value),
    otToken: computed(() => otToken.value),
    noAppointmentsCache: computed(() => noAppointmentsCache.value),
    // setters
    cacheAppointmentData,
    cacheAppointmentBranches,
    cacheAppointmentSettings,
    cacheBookingData,
    cacheOtToken,
    cacheNoAppointments,
  }
})

export const useAppointmentRecentsStore = defineStore('appointmentRecents', () => {
  const recentAppointments = ref<RecentAppointment[]>([])
  const appointmentCount = ref(0)

  function setRecentAppointments(appointments: RecentAppointment[]) {
    recentAppointments.value = appointments
  }

  function setAppointmentCount(count: number) {
    appointmentCount.value = count
  }

  return {
    recentAppointments: computed(() => recentAppointments.value),
    appointmentCount: computed(() => appointmentCount.value),
    setRecentAppointments,
    setAppointmentCount,
  }
})
